<template>
 <div>
    <CRUDCriteria
      :showReset="true"
      :showSearch="false"
    >
    <template v-slot:criteriaRows>
  <v-row>
    <v-col cols="3">
      <FySelect
        v-model="criteriaState.fiscalYear"
        :fyRange="fiscalYearRange"
        class="gl-collateral-bank-criteria-FY-select"
        id="glCollateralBankCriteriaFYSelect"
        label="By FY"
        @input="searchByCriteria"
      />
    </v-col>
    <v-col cols="auto"> <!-- Added this line -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <ReportInfo
            v-if="forceReloadDetails"
            :reportType="reportType"
            :closeDialogBox="closeDialogBox"
            :businessDate="(criteriaState || {}).businessDate || ''"
            @settingDialogVal="settingDialogVal"
          />
          <v-btn
            rounded
            id="saBankCollateralReportBtn"
            class="sai-bankCollateralReport mt-7 ml-10"
            depressed
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="openComponent('printBankCollateral')"
            :disabled="checkStringEmptiness(criteriaState.fiscalYear)"
          >
            <v-icon left>
              {{ icons.mdiPrinter }}
            </v-icon>
            Print Collateral
          </v-btn>
        </template>
        <span>Print Collateral</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

    </CRUDCriteria>
  </div>
</template>
<script>
import {
  mapGetters, mapState,
} from 'vuex';
import {
  mdiPrinter,
} from '@mdi/js';
import { calculateFiscalYears } from '../../../util/shared/tmc-global';
import { checkStringEmptiness } from '../../../util/shared/vue-global';
import CRUDCriteria from '../../common/base/crud/CRUDCriteria.vue';
import FySelect from '../../common/FySelect.vue';
import ReportInfo from '../Transaction/ReportInfo.vue';
import { queryStringCalcForCollateralReports } from '../Sai/report.util';

export default {
  name: 'CollateralBankCriteria',
  components: {
    CRUDCriteria,
    FySelect,
    ReportInfo,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'transactionCriteria',
    },
  },
  data: () => ({
    icons: {
      mdiPrinter,
    },
    reportType: '',
    forceReloadDetails: false,
    closeDialogBox: false,
  }),
  created() {
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'item', 'items']),
    ...mapState({
      fiscalYearRange: (state) => {
        const registerdYears = state.glDaily.glDailyTransaction.regYears || {};
        return calculateFiscalYears(registerdYears);
      },
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    queryStringForCollateral: {
      cache: false,
      get() {
        return queryStringCalcForCollateralReports({
          criteria: this.criteriaState,
          token: this.getAuthToken,
          isSaiMonthly: true,
        });
      },
    },
  },
  methods: {
    checkStringEmptiness,
    searchByCriteria() {
      this.handleLoadCRUDList();
    },
    handleLoadCRUDList() {
      this.$emit('loadCRUDList');
    },
    openComponent(val) {
      this.reportType = val;
      this.closeDialogBox = true;
      this.forceReloadDetails = true;
    },
    settingDialogVal(value) {
      this.closeDialogBox = value;
      this.forceReloadDetails = false;
    },
  },
};
</script>
